import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IconControl from './icon-control'
import linkify from '../lib/linkify'
import { Link } from 'gatsby'
import { MobileDeviceWidth } from '../lib/constants'

const StyledDiv = styled.div`
  background: ${colours.white};
  color: ${colours.darkBlue};
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 15px;
  padding: 12px;
`
const StyledIcon = styled(IconControl)`
  margin-right: 6px;
`

const StyledLink = linkify(styled.div``)


const StyledSpan = styled.span`
  :hover {
    color: ${colours.darkBlue} !important;
  }
  color: ${colours.darkBlue} !important;

`
interface IProps {
  text: string  
}

const MobileMaskControl = (props: IProps) => (
 
  <StyledDiv>
    <StyledLink>
      <StyledSpan>
          {props.text == 'Planned Burns Vic' &&  <IconControl icon="external-link-square-alt" /> }
           {props.text == 'Bushfire Management Strategies' &&  <IconControl icon="external-link-square-alt" /> }
         {props.text == 'State Map view' &&  <IconControl icon="home" /> }
        {props.text}
      </StyledSpan>
    </StyledLink>
  </StyledDiv>
)

export default MobileMaskControl
